import React from 'react';
import './Footer.css';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer site-footer--app">
            <div className="site-footer-main site-footer-main--app">
                <p className="site-footer-copyright">
                    © {currentYear} NeuraTrader. All rights reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;
